module.exports = __webpack_public_path__ + "static/img/d6-2rw.4343769.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/traditional/home/pc/role/d6-2rw.png
// module id = dv2W
// module chunks = 0